export const About = ({ t }) => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-zinc-950 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 relative">
            <div className="relative overflow-hidden border border-zinc-800">
              <img
                src="https://images.pexels.com/photos/8986105/pexels-photo-8986105.jpeg"
                alt="T-CARS workshop philosophy"
                className="w-full h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-red-600 px-6 py-4 hidden md:block">
              <span className="font-heading text-zinc-950 text-3xl font-black tracking-tight">
                EST. 2019
              </span>
            </div>
          </div>

          <div className="lg:col-span-6 lg:pl-6">
            <span className="overline">{t.about.overline}</span>
            <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
              {t.about.title}
            </h2>

            <div className="mt-8 space-y-5 font-body text-zinc-400 leading-relaxed text-base md:text-lg">
              <p>{t.about.paragraph_1}</p>
              <p>{t.about.paragraph_2}</p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-zinc-800 pt-8">
              {t.about.stats.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label}`}>
                  <div className="font-heading text-3xl md:text-4xl font-bold text-red-600 tracking-tight">
                    {s.value}
                  </div>
                  <div className="font-body text-xs font-medium uppercase tracking-wider text-zinc-500 mt-1.5">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
